const gk_timelineBlock = {
  load() {
    const blocks = document.querySelectorAll('.TimelineBlock');
    if (!blocks.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const item = entry.target;
        const index = parseInt(item.dataset.index, 10) || 0;
        const delay = Math.min((index - 1) * 100, 600);

        setTimeout(() => item.classList.add('is-visible'), delay);

        observer.unobserve(item);
      });
    }, {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.15,
    });

    blocks.forEach((block) => {
      const items = block.querySelectorAll('.TimelineBlock-item');
      items.forEach((item) => observer.observe(item));

      if (block.classList.contains('-orientation-horizontal')) {
        this.initHorizontalNav(block);
      }
    });
  },

  initHorizontalNav(block) {
    const track = block.querySelector('.TimelineBlock-track');
    const prevBtn = block.querySelector('.TimelineBlock-nav.-prev');
    const nextBtn = block.querySelector('.TimelineBlock-nav.-next');

    if (!track || !prevBtn || !nextBtn) return;

    const getItemWidth = () => {
      const firstItem = track.querySelector('.TimelineBlock-item');
      if (!firstItem) return 320;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      return firstItem.offsetWidth + gap;
    };

    const updateButtons = () => {
      const { scrollLeft, scrollWidth, clientWidth } = track;
      prevBtn.toggleAttribute('disabled', scrollLeft <= 0);
      nextBtn.toggleAttribute('disabled', scrollLeft + clientWidth >= scrollWidth - 1);
    };

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getItemWidth(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getItemWidth(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });

    updateButtons();
  },
};

export default gk_timelineBlock;
